import {QuestionDataType} from '../types/question';
import {QuestionId} from '../store/navigation';

export const QuestionData: QuestionDataType = {
  question_landing: {
    id: 'question_landing',
    title: 'Hi There',
    optional: false,
    progressValue: 0,
    nextStepId: 'q1_name',
  },
  q1_name: {
    id: 'q1_name',
    title: 'First things first, what should we call you?',
    optional: false,
    progressValue: 10,
    nextStepId: 'q2_your_vehicle',
  },
  q2_your_vehicle: {
    id: 'q2_your_vehicle',
    title: 'Before we talk EVs, what are you driving at the moment?',
    optional: false,
    progressValue: 20,
    nextStepId: 'q3_vehicle_use',
  },
  q3_vehicle_use: {
    id: 'q3_vehicle_use',
    title: 'In a nutshell, what would you mainly need your EV for?',
    subHeading: 'Choose one activity',
    optional: false,
    progressValue: 30,
    singleSelectOptions: [
      {
        label: 'The joy of driving',
        value: 'joy_driving',
        nextStepId: 'q4_passengers',
      },
      {
        label: 'Daily commuting',
        value: 'daily_commuting',
        nextStepId: 'q4_passengers',
      },
      {label: 'Family car', value: 'family_car', nextStepId: 'q4_passengers'},
      {label: 'Road trips', value: 'road_trips', nextStepId: 'q4_passengers'},
      {label: 'Rideshare', value: 'ride_share', nextStepId: 'q4_passengers'},
      {
        label: 'Exploring (e.g. beaches & backroads)',
        value: 'exploring',
        nextStepId: 'q7_new_vehicle_features',
      },
      {
        label: 'Transporting goods',
        value: 'transporting_goods',
        nextStepId: 'q7_new_vehicle_features',
      },
      {
        label: 'Towing (e.g. boats & campers)',
        value: 'towing',
        nextStepId: 'q14_results',
      },
      {
        label: 'Trade & carrying tools',
        value: 'trade_tools',
        nextStepId: 'q6_fits_your_trade',
      },
      {
        label: 'Off-roading (e.g. 4x4 touring)',
        value: 'off_roading',
        nextStepId: 'q14_results',
      },
    ],
  },
  q4_passengers: {
    id: 'q4_passengers',
    title: 'How many passengers do you think you’ll need room for?',
    optional: false,
    progressValue: 40,
    min: 1,
    max: 7,
    increment: 1,
    nextStepId: 'q7_new_vehicle_features',
  },
  q5_towing_preference: {
    id: 'q5_towing_preference',
    title: 'What’s your ideal towing vehicle?',
    optional: false,
    progressValue: 40,
    singleSelectOptions: [
      {label: 'SUV', value: 'suv', nextStepId: 'q7_new_vehicle_features'},
      {label: 'Ute', value: 'ute ', nextStepId: 'q14_results'},
    ],
  },
  q6_fits_your_trade: {
    id: 'q6_fits_your_trade',
    title:
      'When it comes to your trade, what’s the best kind of vehicle to help you get the job done? ',
    optional: false,
    progressValue: 40,
    singleSelectOptions: [
      {label: 'Van', value: 'van', nextStepId: 'q7_new_vehicle_features'},
      {label: 'Ute', value: 'ute ', nextStepId: 'q14_results'},
    ],
  },
  q7_new_vehicle_features: {
    id: 'q7_new_vehicle_features',
    title: 'What sparks your interest the most in a new EV?',
    subHeading: 'Select up to 3',
    optional: false,
    progressValue: 60,
    multiSelectOptions: [
      {
        label: 'Performance & AWD',
        value: 'performance_and_awd',
        type: 1,
      },
      {
        label: 'Versatility & carrying capacity',
        value: 'versatility_and_carrying_capacity',
        type: 1,
      },
      {
        label: 'Touring',
        value: 'touring_ability',
        type: 1,
      },
      {
        label: 'Sporty styling',
        value: 'sporty_styling',
        type: 1,
        excludes: ['retro_styling'],
      },
      {
        label: 'Retro styling',
        value: 'retro_styling',
        type: 1,
        excludes: ['sporty_styling'],
      },
      {
        label: 'Comfort & styling',
        value: 'comfort_and_styling',
        type: 2,
      },
      {
        label: 'Driving performance',
        value: 'driving_performance',
        type: 2,
      },
      {
        label: 'Technology & infotainment',
        value: 'technology_and_infotainment',
        type: 0,
      },
      {
        label: 'The latest safety features',
        value: 'latest_safety_features',
        type: 0,
      },
      {
        label: 'Savings on fuel & affordability',
        value: 'savings_on_fuel_and_affordability',
        type: 0,
      },
      {
        label: 'Sustainability',
        value: 'sustainability',
        type: 0,
      },
    ],
  },
  q8_address: {
    id: 'q8_address',
    title:
      'Let’s see what public chargers around you. Could we have your postcode?',
    optional: false,
    progressValue: 80,
  },
  q9_charging_type: {
    id: 'q9_charging_type',
    title: 'Do you have any of the following energy options at your home?',
    optional: false,
    subHeading: 'Select all that apply',
    progressValue: 90,
    multiSelectOptions: [
      {
        label: '3 phase power',
        value: '3_phase_power',
      },
      {
        label: 'Solar power',
        value: 'solar_power',
      },
      {
        label: 'Green energy plan',
        value: 'green_energy_plan',
      },
      {
        label: 'EV wall charger',
        value: 'ev_wall_charger',
      },
      {
        label: 'None of the above',
        value: 'none',
      },
    ],
  },
  q10_charging_home: {
    id: 'q10_charging_home',
    title:
      'There’s no place to charge like home. Can you have an EV charger installed at yours?',
    optional: false,
    progressValue: 100,
    singleSelectOptions: [
      {label: 'Yes', value: 'yes', nextStepId: 'q12_travel_distance'},
      {label: 'No', value: 'no', nextStepId: 'q11_charging_work'},
      {label: 'Unsure', value: 'unsure', nextStepId: 'q11_charging_work'},
    ],
  },
  q11_charging_work: {
    id: 'q11_charging_work',
    title: 'Do you have regular access to a shared charging station?',
    optional: false,
    progressValue: 100,
    singleSelectOptions: [
      {label: 'Yes', value: 'yes', nextStepId: 'q12_travel_distance'},
      {label: 'No', value: 'no', nextStepId: 'q12_travel_distance'},
      {label: 'Unsure', value: 'unsure', nextStepId: 'q12_travel_distance'},
    ],
  },
  q12_travel_distance: {
    id: 'q12_travel_distance',
    title:
      'Last question! On average, how far would you say you travel each day?',
    optional: false,
    progressValue: 100,
    increment: 1,
    label: 'kms',
    min: 0,
    max: 300,
    nextStepId: 'q14_results',
  },
  q13_form: {
    id: 'q13_form',
    title: 'All set! Let us know where to send your results',
    optional: false,
    progressValue: 100,
    nextStepId: 'q14_results',
  },
  q14_results: {
    id: 'q14_results',
    title: 'Here are your results!',
    optional: false,
    progressValue: 100,
  },
};

export const postcode_data_sample = [
  {
    label: 'NSW',
    value: 'NSW',
  },
  {
    label: 'VIC',
    value: 'VIC',
  },
  {
    label: 'QLD',
    value: 'QLD',
  },
  {
    label: 'WA',
    value: 'WA',
  },
  {
    label: 'SA',
    value: 'SA',
  },
  {
    label: 'TAS',
    value: 'TAS',
  },
  {
    label: 'ACT',
    value: 'ACT',
  },
  {
    label: 'NT',
    value: 'NT',
  },
];

export const QuestionStepName: Partial<Record<QuestionId, string>> = {
  question_landing: 'Start',
  q2_your_vehicle: 'Current Vehicle',
  q3_vehicle_use: 'Intended Use',
  q4_passengers: 'Passengers',
  q5_towing_preference: 'Towing Preference',
  q6_fits_your_trade: 'Fits Your Trade',
  q7_new_vehicle_features: 'New Vehicle Features',
  q8_address: 'Address',
  q9_charging_type: 'Charging Type',
  q10_charging_home: 'Charging Home',
  q11_charging_work: 'Charging Work',
  q12_travel_distance: 'Travel Distance',
  q13_form: 'Subscribe to eNewsletter',
  q14_results: 'Results',
};
